
import { Component, InjectReactive, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class';

import { Views } from '@/enums';

@Component({
  components: {
  }
})
export default class CategorySelector extends Vue {
  @Getter categories!: Category[];
  @Getter activeCategory!: Category;
  @InjectReactive() isMobile!: boolean;

  get activeCategoryName() {
    return this.activeCategory?.name || '';
  }

  get showCategorySelector() {
    return [Views.CHOOSE_FOOD_CATEGORY, Views.PRODUCT_ADD].includes(this.$route.name as Views);
  }

  get showCategoryDescription() {
    return [Views.CHOOSE_FOOD_CATEGORY].includes(this.$route.name as Views) && !this.isMobile && this.activeCategory?.description;
  }

  handleChooseCategory(category) {
    this.$emit('categoryChange', category);
  }
}
